<script setup lang="ts">
import PlannerDetailTemplate from '~/components/templates/PlannerDetailTemplate/PlannerDetailTemplate.vue';
import { graphql } from '~/gql';

const route = useRoute();
const id = getIntQuery(route.params['id']);

if (id == null) {
  throw new Error(`invalid id: ${id}`);
}

const { data } = await useAsyncQuery(
  graphql(`
    query PlannerIndexPage($id: ID!) {
      planner(id: $id) {
        name
        isNoIndex
        myStoryUrl
        ...PlannerDetailTemplate
      }
    }
  `),
  { id: id.toString() },
  { apollo: { fetchPolicy: 'no-cache' } }
);

useAppMeta({
  title: () => data.value?.planner?.name,
  noindex: () => data.value?.planner?.isNoIndex ?? false,
});

definePageMeta({
  layout: 'no-footer',
});
</script>

<template>
  <PlannerDetailTemplate v-if="data?.planner != null" :planner="data.planner" />
</template>
